import React from "react";

const agentTabs = ["active", "offline", "total"];

export default function AgentPanel({
  agents,
  filteredAgents,
  selectedAgentTab,
  setSelectedAgentTab,
  searchQuery,
  setSearchQuery,
  FetchDriverCall,
  setNotificationAgent,
  setNotificationModalOpen,
}) {
  const getTabCount = (tab) => {
    if (tab === "total") return agents.length;
    return agents.filter((a) => a.dutyStatus?.toLowerCase() === tab).length;
  };

  return (
    <div className="w-[360px] min-w-[360px] bg-gray-50 border-l rounded-lg shadow-sm flex flex-col h-full">
      {/* HEADER */}
      <div className="px-3 py-2 border-b text-2xl font-semibold">
        <p className="mb-3">Agents</p>

        <div className="flex items-between space-x-2 text-sm w-full">
          <input
            type="text"
            placeholder="Search"
            className="border px-2 py-1 rounded w-full"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button onClick={FetchDriverCall} className="text-orange-500">
            ⟳
          </button>
        </div>
      </div>

      {/* AGENT TABS */}
      <div className="flex justify-around mt-2 text-center border-b pb-1 mx-2 bg-white shadow-sm">
        {agentTabs.map((tab) => (
          <div
            key={tab}
            className={`px-2 py-1 cursor-pointer text-xs font-medium ${
              selectedAgentTab === tab
                ? "text-orange-600 border-b-2 border-orange-600"
                : "text-gray-600"
            }`}
            onClick={() => setSelectedAgentTab(tab)}
          >
            <div className="text-lg font-bold">{getTabCount(tab)}</div>
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </div>
        ))}
      </div>

      {/* AGENT LIST */}
      <div className="p-3 space-y-2 h-full overflow-y-auto max-h-[calc(100vh-180px)]">
        {filteredAgents.map((agent) => (
          <div
            key={agent.id}
            className="flex flex-col bg-white p-3 pl-4 shadow-sm rounded-md border-l-4 cursor-pointer hover:bg-gray-50"
            style={{
              borderLeftColor:
                agent.dutyStatus === "active" ? "#22C55E" : "#94A3B8",
            }}
          >
            {/* NAME + NOTIFICATION + STATUS */}
            <div className="flex justify-between items-center">
              <div className="font-semibold text-sm text-gray-900">
                {agent.fullName}
              </div>

              <div className="flex items-center gap-2">
                <button
                  className="text-orange-600 hover:text-orange-800"
                  onClick={() => {
                    setNotificationAgent(agent);
                    setNotificationModalOpen(true);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 17h5l-1.405-1.405C19.79 14.79 20 13.918 20 13V9a7.002 7.002 0 00-5-6.708V2a1 1 0 00-2 0v.292A7.002 7.002 0 006 9v4c0 .918.21 1.79.595 2.595L5 17h5m5 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                  </svg>
                </button>

                {/* STATUS BADGE  */}
                <span
                  className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full
            ${
              agent.dutyStatus === "active"
                ? "bg-green-100 text-green-700"
                : agent.dutyStatus === "offline"
                  ? "bg-blue-100 text-blue-700"
                  : "bg-yellow-100 text-yellow-700"
            }`}
                >
                  <span className="w-2 h-2 rounded-full bg-current" />
                  {agent.dutyStatus?.charAt(0).toUpperCase() +
                    agent.dutyStatus?.slice(1)}
                </span>
              </div>
            </div>

            <hr className="my-2 border-gray-200" />

            {/* TEAM NAME  */}
            {agent.teamName && (
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 7h18M3 12h18M3 17h18"
                  />
                </svg>
                {agent.teamName}
              </div>
            )}
          </div>
        ))}

        {filteredAgents.length === 0 && (
          <div className="text-xs text-gray-400 text-center py-4">
            No agents found.
          </div>
        )}
      </div>
    </div>
  );
}
